import _ from "underscore";
    let populateParentNodes = function (groups, parent, groupsDictionary) {
            let i;
            let id;
            let node;
            let nodeWithParent;
            let children;

            for (i in groups) {
                if (groups.hasOwnProperty(i)) {
                    node = groups[i];
                    id = node.id;
                    nodeWithParent = _.extend({}, node, {
                        parent: parent
                    });
                    groupsDictionary[id] = nodeWithParent;
                    children = node.children || node.groups;
                    if (children) {
                        populateParentNodes(children, nodeWithParent, groupsDictionary);
                    }
                    if (id === "GroupCompanyId") {
                        // we traversed entire organization, all groups are populated
                        break;
                    }
                }
            }
        };

    export default {
        populateParentNodes: function (groups: IIdEntity[], parent: IIdEntity | null = null): IIdDictionary<IIdEntity> {
            let groupsDictionary: IIdDictionary<IIdEntity> = {};
            populateParentNodes(groups, parent, groupsDictionary);
            return groupsDictionary;
        }
    };
